import { render } from "./AddCustomAction.vue?vue&type=template&id=a7488586&scoped=true"
import script from "./AddCustomAction.vue?vue&type=script&lang=js"
export * from "./AddCustomAction.vue?vue&type=script&lang=js"

import "./AddCustomAction.vue?vue&type=style&index=0&id=a7488586&scoped=true&lang=less"

import exportComponent from "/home/baltazor/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7488586"]])

export default __exports__